import type { FC } from 'react';
import { getClasses } from '@/_utils/classnames';
import styles from './CardContent.module.css';
import type { CardContentProps } from './CardContent.types';

export const CardContent: FC<CardContentProps> = ({
  children,
  withAside,
  withTitle,
  withPadding,
  withMiniTitle,
  isFullHeight,
  contentOverflow,
}) => {
  const cardContentClasses: string = getClasses(styles.cardContent, {
    [styles.cardContentFull]: isFullHeight,
    [styles.cardContentWithPadding]: isFullHeight && withPadding,
    [styles.cardContentWithTitle]: isFullHeight && withTitle,
    [styles.cardContentWithAside]: withAside,
    [styles.cardContentWithMiniTitle]: withMiniTitle,
    [styles.cardContentOverflow]: contentOverflow,
  });

  return <div className={cardContentClasses}>{children}</div>;
};
